import type { ShortVideo } from './useFetchShorts';
import type { ShortVideoProperty } from '~/core/entities/property';

export function mapPropertyToShortVideo(
	property: ShortVideoProperty
): ShortVideo | null {
	const short = property.shorts?.[0];
	if (!short) return null;

	return {
		property,
		videoUrl: short.url,
		thumbnailUrl: short.thumbnail ?? null,
		videoWidth: short.width,
		videoHeight: short.height
	};
}
